import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { MessagesService }    from '../../app-lite/messages/messages.service';
import { PasswordsService }   from './passwords.service';
import { ResetPasswordModel } from './typings/password.reset';

@Component({
  selector   : 'reset-password',
  template: require('./password.reset.component.html')
})
export class ResetPasswordComponent implements OnInit {
  @Input() id        : string;
  @Input() resetToken: string;

  user : ResetPasswordModel = {
    confirm_password: '',
    id              : '',
    password        : '',
    reset_token     : ''
  };

  constructor (
    private messagesService : MessagesService,
    private passwordsService: PasswordsService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.user = {
      confirm_password: '',
      id              : this.id,
      password        : '',
      reset_token     : this.resetToken
    };
  }

  submit ( form : NgForm ) : void {
    this.passwordsService.reset(this.user)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PASSWORD_RESET'), 'success');

      form.reset();

      this.router.stateService.go('app.login');
    })
    .catch(error => this.messagesService.error(error));
  }
}
